/**
 * wbn-announcement-pin.js
 *
 * Keeps the announcement bar on screen whenever its `position: sticky` stops working.
 *
 * THE BUG (recordings homepage, desktop, page scrolled): open the
 * The header right below it never moves (39 px in both) because `.site-header--stuck`
 * is `position: fixed`, which the same lock cannot touch. That is why the bar alone
 * THE FIX: watch the outcome, not the cause. Whenever the sticky wrapper has drifted
 * height so the page underneath does not shift; release the moment the wrapper is
 * back at the top under its own power. The wrapper deliberately keeps
 * correct again as soon as whatever broke it lets go. So this covers a lock that
 */
(function () {
  'use strict';

  if (window.__wbnAnnouncementPin) {
    return;
  }
  window.__wbnAnnouncementPin = true;

  var PINNED_CLASS = 'wbn-announcement-pinned';
  var root = document.documentElement;
  var bar = null;
  var wrapper = null;
  var pinned = false;
  var frame = 0;
  var watchdog = 0;
  // The bar only breaks while the page is scrolled -- at scroll 0 it survives the
  // same drawer (see THE BUG above). Tracked from the scroll listener rather than
  // read back from window.scrollY, because a scroll-offset read can flush pending
  // layout the same way the rect read in apply() does, which would defeat the point.
  var scrolled = false;

  function find() {
    if (bar && root.contains(bar)) {
      return true;
    }
    bar = document.querySelector('.announcement-bar');
    wrapper = bar ? bar.closest('.shopify-section') : null;
    // A freshly rendered bar carries none of the pinned state we left behind.
    pinned = false;
    return !!(bar && wrapper);
  }

  function apply() {
    frame = 0;

    // The rect read below forces a synchronous layout, and at scroll 0 there is
    // nothing it can detect. That matters during load: the observer watches
    // childList on <body>, which every third-party widget trips as it mounts its
    // root, so without this guard the bar paid for one forced layout per frame
    // for a state that cannot occur yet. Measured at 98 ms of main-thread time
    // for 3 ms of actual scripting on a product page .
    if (!pinned && !scrolled) {
      return;
    }

    if (!find()) {
      return;
    }

    // The wrapper stays sticky in both states, so its own position is the test:
    // 0 while sticky is doing its job, negative once something has broken it.
    var displaced = wrapper.getBoundingClientRect().top < -1;

    if (displaced === pinned) {
      return;
    }

    if (displaced) {
      // Measure before the bar leaves flow, or the wrapper collapses and the whole
      // page jumps up by the bar's height behind the drawer overlay.
      wrapper.style.height = wrapper.getBoundingClientRect().height + 'px';
      root.classList.add(PINNED_CLASS);
      // While pinned the page is usually scroll-locked, so no scroll events arrive
      // to tell us when it recovers. Poll — cheaply, and only for as long as the
      // bar is actually broken.
      watchdog = window.setInterval(schedule, 400);
    } else {
      root.classList.remove(PINNED_CLASS);
      wrapper.style.height = '';
      window.clearInterval(watchdog);
      watchdog = 0;
    }

    pinned = displaced;
  }

  function schedule() {
    if (frame) {
      return;
    }
    frame = window.requestAnimationFrame(apply);
  }

  // Drawers announce themselves by mutating <html>/<body> (inline lock styles or a
  // state class) and by mounting their root into <body>. Attributes only, no subtree:
  // the callback is one rect read behind a requestAnimationFrame coalescer.
  var observer = new MutationObserver(schedule);
  observer.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style'],
    childList: true
  });

  window.addEventListener('scroll', function () {
    scrolled = true;
    schedule();
  }, { passive: true });
  window.addEventListener('pageshow', function () {
    // A restored navigation can come back already scrolled without ever firing a
    // scroll event, so assume scrolled here and let apply() settle the real state.
    scrolled = true;
    schedule();
  });
  document.addEventListener('shopify:section:load', schedule);

  apply();
})();
